// cu-form.js — updated for the Vercel function
function validateForm() {
    const errors = [];
    const name = document.getElementById("f-name").value.trim();
    const email = document.getElementById("f-email").value.trim();
    const company = document.getElementById("f-company").value.trim();
    const message = document.getElementById("f-message").value.trim();
    const consent = document.getElementById("f-consent").checked;
    if (!name) errors.push("Full name is required.");
    if (!company) errors.push("Company or organization is required.");
    if (!message) errors.push("Message is required.");
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) errors.push("Email address is required.");
    else if (!emailRe.test(email)) errors.push("Enter a valid email address.");
    if (!consent) errors.push("You must agree to the privacy policy and terms to continue.");
    return errors;
}
async function handleSubmit(event) {
    event.preventDefault();
    const errors = validateForm();
    if (errors.length) {
        showErrors(errors);
        return;
    }
    const payload = {
        name: document.getElementById("f-name").value.trim(),
        email: document.getElementById("f-email").value.trim(),
        company: document.getElementById("f-company").value.trim(),
        message: document.getElementById("f-message").value.trim(),
        consent: document.getElementById("f-consent").checked
    };
    const btn = document.querySelector(".submit-btn");
    btn.disabled = true;
    btn.textContent = "Sending\u2026";
    try {
        const res = await fetch("/api/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        if (!res.ok) {
            const data = await res.json().catch(()=>({}));
            btn.disabled = false;
            btn.textContent = "Submit Form";
            showErrors([
                data.message || "Something went wrong. Please try again."
            ]);
            return;
        }
        showSuccess();
    } catch (err) {
        btn.disabled = false;
        btn.textContent = "Submit Form";
        showErrors([
            "Network error. Please check your connection and try again."
        ]);
    }
}
function showSuccess() {
    document.querySelector(".cu-form").innerHTML = `<p style="font-size:15px;">Message sent \u{2014} we'll be in touch shortly.</p>`;
}
function showErrors(errors) {
    document.getElementById("error-banner")?.remove();
    const banner = document.createElement("div");
    banner.id = "error-banner";
    banner.style.cssText = "background:#fdecea;color:#b3261e;border-radius:8px;padding:10px 14px;font-size:13px;margin-top:12px";
    banner.innerHTML = errors.map((e)=>`<div>\xb7 ${e}</div>`).join("");
    document.querySelector(".cu-form").append(banner);
}

//# sourceMappingURL=web-build.ce899ac5.js.map
